module.exports = __webpack_public_path__ + "img/icon-star4-active.f2d005d6.png";